export default (value) => {
  if (typeof value === 'undefined') return value;

  if (typeof value !== 'string' || value.length < 5) {
    return value;
  }

  return '(XX) X XXXX-' + value.substr(value.length - 4);
};
